import { ReactElement } from 'react'
import { useParams } from 'react-router-dom'
import { buildErrorMessage } from '@constants'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useSnackbar } from '@ui/snackbar'
import AddPlanItemButton from '../AddPlanItemButton'

interface Props {
  title: string
  request: (projectId: string, params: Record<string, string | number | boolean>) => Promise<void>
  params: Record<string, string | number | boolean>
  'data-cy'?: string
}

const AddPlanItem = ({ title, request, params }: Props): ReactElement => {
  const { enqueueSnackbar } = useSnackbar()
  const { projectId } = useParams()
  const queryClient = useQueryClient()

  const { isLoading, mutate } = useMutation(
    () => {
      return request(projectId as string, params)
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['getPlans', projectId])
        enqueueSnackbar('Plan wurde erfolgreich erstellt', { variant: 'success' })
      },
      onError: (e: Error) => {
        enqueueSnackbar(buildErrorMessage(e, 'Fehler beim Erstellen der Pläne'), {
          variant: 'error',
        })
      },
    },
  )

  return <AddPlanItemButton title={`${title}`} isLoading={isLoading} onClick={() => mutate()} />
}

export default AddPlanItem
